
import { SetupContext, reactive, watch, onMounted } from 'vue'

export default {
  name: 'InputInlineText',

  props: {
    id: String,
    placeholder: String,
    error: {
      type: Boolean,
      default: false
    },
    req: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    value: String,
    name: String
  },

  setup(props: any, context: SetupContext) {
    const updateValue = (e: any) => {
      context.emit('call-input-change', e.target.value)
    }
    const state: {
      isVal: boolean
    } = reactive({
      isVal: false
    })

    const updateState = (e: any) => {
      if (!e.target.value) {
        state.isVal = false
      }
    }

    onMounted(() => {
      if (props.value && !props.error) {
        state.isVal = true
      }
    })

    watch(
      () => props.value,
      () => {
        if (props.value) {
          state.isVal = true
        }
      }
    )

    return {
      updateValue,
      updateState,
      state
    }
  }
}
